import { combineReducers } from '@reduxjs/toolkit';

import { confirmNotificationReducer } from './confirm-notification';
import { psNotificationsReducer } from './ps-notifications/slice';

export const notificationsReducer = combineReducers({
    psNotifications: psNotificationsReducer,
    confirmNotification: confirmNotificationReducer,
});
